import { Theme } from "@mui/material";

export const ToastStyles = (theme: Theme) => {
    return {
        success: {
            color: theme.colors["neutral.950"],
            background: theme.colors["green.500"],
        },
        error: {
            color: theme.colors["neutral.950"],
            background: theme.colors["red.400"],
        },
        warning: {
            color: theme.colors["neutral.950"],
            background: theme.colors["yellow.300"],
        }
    };
};